import { useCallback } from 'react';
import { TextField, TextFieldProps } from '../text-field';

import { format } from './format';
import { payment } from '../common/validation';

export const CardExpirationDateField = ({ fieldProps, ...props }: TextFieldProps) => {
  const attachFormatter = useCallback((input?: HTMLInputElement) => {
    if (!input) {
      return;
    }
    payment.formatCardExpiry(input);
  }, []);

  return (
    <TextField
      fullWidth
      type="text"
      autoComplete="on"
      inputProps={{
        inputMode: 'numeric',
        autoComplete: 'on',
        autocompletetype: 'cc-exp',
        pattern: '\\d*',
        // 2 symbols for day + 3 for ' / ' + 4 for year
        maxLength: 9,
      }}
      label="Expiration"
      inputRef={attachFormatter}
      fieldProps={{
        ...fieldProps,
        parse: format,
      }}
      {...props}
    />
  );
};
